import React, { useEffect, useState, useRef } from "react";
import { bool, string, shape, arrayOf } from "prop-types";
import { connect, useDispatch } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import * as i18nUtils from "util/i18n";
import { goBack } from "connected-react-router";
import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";
import { ResponsiveHeader } from "pages/_components/header";

import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Selector from "pages/_components/fields/formik/Selector";
import CustomText from "pages/_components/CustomText/CustomText";
import ErrorPopup from "../_components/ErrorPopup";
import Stepper from "../_components/Stepper";

const PAGE_ID = "StepSelectEnrolledUserRole";
const FORM_ID = "onboarding.step.personalData";

const StepSelectEnrolledUserRole = ({ isMobile, companyRoleList, personalDataStatus }) => {
    const dispatch = useDispatch();
    const [error, setError] = useState("");
    const isLoading = !companyRoleList[0];
    const formRef = useRef(null);

    useEffect(() => {
        dispatch(onboardingActions.listPersonalInfoRequest(null));
    }, []);

    useEffect(() => {
        if (personalDataStatus && personalDataStatus === "SUCCESS") {
            dispatch(onboardingActions.resetPersonalDataStatus());
        } else if (personalDataStatus?.length && personalDataStatus !== "FETCHING") {
            setError(personalDataStatus);
            dispatch(modalActions.modalShow());
        }
    }, [personalDataStatus]);

    const submitIsAllowed = ({ values }) => {
        const { companyRole } = values;
        return !!companyRole;
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const requiredString = i18nUtils.get("forms.inputFile.massivePayments.invalid.required");

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            companyRole: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                companyRole: Yup.string().required(requiredString),
            }),
        onSubmit: (values) => {
            if (values) {
                dispatch(onboardingActions.enrolledUserSelectRole(values?.companyRole));
            }
        },
    };

    return (
        <>
            {isMobile && (
                <ResponsiveHeader ticket id="onboarding.enrolled.user" onClickBack={isMobile && onHeaderBack} />
            )}
            <MainContainer showLoader={isLoading}>
                {!isMobile && <Head title="onboarding.enrolled.user" onBack={isMobile && onHeaderBack} />}
                <Stepper isMobile={isMobile} page={PAGE_ID} />
                <h1 className="text-center" style={{ textAlign: "left" }}>
                    <CustomText text={i18nUtils.get("onboarding.enrolled.user.select.role", "Seleccioná un rol")} />
                </h1>
                <Formik {...formikProps} ref={formRef}>
                    {(allFormik) => (
                        <Form className="above-the-fold">
                            <Field
                                component={Selector}
                                idForm={FORM_ID}
                                name="companyRole"
                                options={companyRoleList || []}
                                label={`${i18nUtils.get(
                                    "onboarding.personalData.companyRole.label",
                                    "¿Qué rol cumplís en la compañía?",
                                )}`}
                                placeholder={`${i18nUtils.get(
                                    "onboarding.personalData.selectorPlaceholder",
                                    "Elegir una opción",
                                )}`}
                            />
                            <div className="form-actions">
                                <Button
                                    bsStyle="primary"
                                    label="global.continue"
                                    loading={personalDataStatus === "FETCHING"}
                                    type="submit"
                                    block
                                    disabled={!submitIsAllowed(allFormik)}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>

            <ErrorPopup error={error} handleClick={() => dispatch(modalActions.modalClose())} />
        </>
    );
};

StepSelectEnrolledUserRole.propTypes = {
    isMobile: bool.isRequired,
    companyRoleList: arrayOf(shape({})).isRequired,
    fetching: bool.isRequired,
    personalDataStatus: string.isRequired,
};

const mapStateToProps = (state) => ({
    companyRoleList: onboardingSelectors.getCompanyRoleList(state),
    fetching: onboardingSelectors.getFetching(state),
    personalDataStatus: onboardingSelectors.getPersonalDataStatus(state),
});

export default connect(mapStateToProps)(StepSelectEnrolledUserRole);
